export const Porbandar = {
    title: "Porbandar",
    title1: "(Birthplace of Mahatma Gandhi)",

    intro: "Porbandar, a coastal city in Gujarat, is historically significant as the birthplace of Mahatma Gandhi. The city is rich in cultural heritage, with beautiful beaches, historic temples, and landmarks associated with India's freedom struggle.",

    attractions: [
        {
            name: "Mahatma Gandhi's Birthplace",
            description: "Mahatma Gandhi's Birthplace, also known as Kirti Mandir, is an important historical site dedicated to the life and teachings of the Father of the Nation. The house has been converted into a museum, displaying photographs, letters, and artifacts related to Gandhi’s early life.",
            location: "Kirti Mandir, Porbandar, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "₹20 per person",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Explore the museum dedicated to Mahatma Gandhi",
                "Learn about Gandhi’s early life and teachings",
                "View historical photographs and letters",
                "Pay tribute to the birthplace of the Father of the Nation",
                "Take a guided tour to understand the significance of the site"
            ],
            mapLink: "https://maps.app.goo.gl/K8w8BxnXhZzEdL9t7",
        },
        {
            name: "Sudama Temple",
            description: "The Sudama Temple is an ancient temple dedicated to Sudama, Lord Krishna's childhood friend. Located on the shores of the Arabian Sea, this temple is famous for its religious significance and peaceful atmosphere.",
            location: "Sudama Mandir, Porbandar, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend prayers and aarti sessions",
                "Meditate in the peaceful temple atmosphere",
                "Take photographs of the temple and surrounding views",
                "Learn about the history and significance of Sudama’s devotion to Krishna",
                "Enjoy the serene atmosphere and beach view"
            ],
            mapLink: "https://maps.app.goo.gl/LnM2tjd7Efn2Bmx7A",
        },
        {
            name: "Porbandar Beach",
            description: "Porbandar Beach is a serene and beautiful coastal destination, known for its peaceful surroundings and historical significance. It’s perfect for relaxation, enjoying sunset views, and engaging in water sports.",
            location: "Porbandar, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Enjoy the sunset by the beach",
                "Take a walk along the coastline",
                "Indulge in water sports like jet-skiing and boating",
                "Relax and meditate by the sea",
                "Take photographs of the scenic views"
            ],
            mapLink: "https://maps.app.goo.gl/88Xs8Gvxx6A2Uhtb9",
        },
        {
            name: "Barda Hills Wildlife Sanctuary",
            description: "Barda Hills Wildlife Sanctuary is located on the outskirts of Porbandar and is home to a diverse range of flora and fauna. The sanctuary offers opportunities for wildlife enthusiasts to explore nature and spot animals like leopards, wild boars, and a variety of birds.",
            location: "Barda Hills, Porbandar, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "₹50 per person",
            bestTimeToVisit: "November to March",
            activities: [
                "Go on a wildlife safari",
                "Spot diverse animal species",
                "Enjoy birdwatching",
                "Take nature walks in the sanctuary",
                "Photography of the beautiful landscape"
            ],
            mapLink: "https://maps.app.goo.gl/QVbhjvWpwnr2F8hP7",
        },
        {
            name: "Huzoor Palace",
            description: "Huzoor Palace is a historic royal palace in Porbandar, known for its magnificent architecture and well-maintained gardens. The palace was once the residence of the local rulers and is now a tourist attraction.",
            location: "Huzoor Palace, Porbandar, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "₹50 per person",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Explore the royal architecture and gardens",
                "Learn about the history of the palace",
                "Admire the exquisite designs and interior decor",
                "Take photographs of the palace and surrounding views",
                "Relax in the tranquil palace grounds"
            ],
            mapLink: "https://maps.app.goo.gl/YHLkdxxXqDcbzHbw6",
        },
        {
            name: "Chowpatty Beach",
            description: "Chowpatty Beach is a popular spot in Porbandar, known for its calm and peaceful ambiance. It’s a perfect place for a leisurely stroll, picnics, and enjoying the coastal beauty of the Arabian Sea.",
            location: "Chowpatty Beach, Porbandar, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Relax by the beach and watch the sunset",
                "Take a walk along the coastline",
                "Engage in beach sports like volleyball",
                "Enjoy local snacks from nearby stalls",
                "Take photographs of the scenic beach views"
            ],
            mapLink: "https://maps.app.goo.gl/WvteFj7Jx5oLPTrD6",
        },
    ]
};
